import { useState } from 'react';

import { lockedFieldTitle } from './LockedFieldset';

/**
 * Fallback editor for any node type without a registered schema-aware UI.
 * Opaque JSON textarea — fine for one-off / custom node types, not what
 * users should be touching for first-class plugins. Kept simple on purpose:
 * the registered forms are where the real UX lives.
 */
export function RawJsonConfig({
  config,
  onChange,
  readOnly = false,
}: {
  config: Record<string, unknown>;
  onChange: (next: Record<string, unknown>) => void;
  /** Whole config locked by a managed-workflow template — shown, not editable. */
  readOnly?: boolean;
}) {
  const [text, setText] = useState(JSON.stringify(config, null, 2));
  const [error, setError] = useState<string | null>(null);

  return (
    <label className="field">
      <span className="field-label">Config (JSON)</span>
      <textarea
        className="textarea"
        rows={10}
        value={text}
        readOnly={readOnly}
        title={readOnly ? lockedFieldTitle : undefined}
        onChange={(e) => {
          if (readOnly) return;
          const t = e.target.value;
          setText(t);
          try {
            const parsed = JSON.parse(t) as Record<string, unknown>;
            setError(null);
            onChange(parsed);
          } catch (err) {
            setError((err as Error).message);
          }
        }}
        spellCheck={false}
        style={{ fontFamily: 'var(--font-mono)', fontSize: 12 }}
      />
      {error ? (
        <span className="field-error">
          <span>{error}</span>
        </span>
      ) : null}
    </label>
  );
}
